import React, { Component } from 'react';
import ChartDisplay from "./components/chartDisplay.js"
import TorGrid from '../torgrid/torgrid';
import moment from 'moment';

class PortfolioPerformanceOverview extends Component {
    constructor(props) {
        super(props);

        this.state = {
            gridData: []
        }

        this.aggregateData = this.aggregateData.bind(this);
    }


    render() {
        return this.getTemplate();
    }

    aggregateData() {
        var { gridData } = this.props;

        var cumSum = 1.0;
        var sum = 0.0;

        var jsObj = {
            date: null,
            sum: null,
            cumSum: null
        };

        var aggList = [];

        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        for (var i = 0; i < gridData.length; i++) {
            var date = new Date(gridData[i]['Report Date']);
            date = monthNames[date.getMonth()];

            if (i === 0) {
                jsObj.date = date;
                sum += gridData[i]['ctr total'];
            } else if (date !== jsObj.date) {
                jsObj.sum = sum * 100;

                cumSum *= (1 + sum);

                jsObj.cumSum = (cumSum - 1) * 100;
                aggList.push(jsObj);

                jsObj = {
                    date: null,
                    sum: null,
                    cumSum: null
                };
                jsObj.date = date;

                sum = gridData[i]['ctr total'];

            } else {
                sum += gridData[i]['ctr total'];
            }
        }

        if (jsObj.date !== null) {
            jsObj.sum = sum * 100;

            cumSum *= (1 + sum);

            jsObj.cumSum = (cumSum - 1) * 100;
            aggList.push(jsObj);
        }

        return aggList;
    }


    getTemplate() {
        const { user } = this.props;
        if (!this.props.gridData || this.props.gridData.length === 0) {
            return null;
        }

        const isReadOnlyUser = user?.userRoles?.includes("Analyst") || user?.userRoles?.includes("Tester");
        const selectedFund = this.props.Fund === "All" ? "All funds" : this.props.Fund;
        const asOfLabel = this.props.AsOfDate ? moment(this.props.AsOfDate).format("MMM D, YYYY") : "";
        const defaultColDef = this.props.defaultColDef ?? {
            sortable: false,
            filter: false,
            floatingFilter: false,
            enableRowGroup: true,
            resizable: true,
            suppressSizeToFit: false,
            flex: 1
        };
        const rankingGrids = [
            { guikey: "portfolioPerformanceTopMTD", title: "Top MTD" },
            { guikey: "portfolioPerformanceBottomMTD", title: "Bottom MTD" },
            { guikey: "portfolioPerformanceTopQTD", title: "Top QTD" },
            { guikey: "portfolioPerformanceBottomQTD", title: "Bottom QTD" },
            { guikey: "portfolioPerformanceTopYTD", title: "Top YTD" },
            { guikey: "portfolioPerformanceBottomYTD", title: "Bottom YTD" }
        ];

        return (
            <div className="portfolio-overview portfolio-performance-overview">
                <header className="portfolio-overview-heading">
                    <div>
                        <h2>Performance Overview</h2>
                    </div>
                    <span className="portfolio-overview-badge">{`${selectedFund}${asOfLabel ? ` · ${asOfLabel}` : ""}`}</span>
                </header>

                {!isReadOnlyUser && (
                    <TorGrid
                        guikey="portfolioPerformanceSummaryTop"
                        isHideDateInputs={true}
                        isHideSaveGridLayout={true}
                        query={`exec [sp_get_ctr_pnl] '${this.props.Fund}', '${moment(this.props.AsOfDate).format("YYYYMMDD")}'`}
                        gridIdentityColumn="position_id"
                        className="dashboardgrid portfolio-overview-summary-grid portfolio-performance-snapshot-grid"
                        rowGroupPanelShow="none"
                        enableFilter={false}
                        domLayout="autoHeight"
                        defaultColDef={defaultColDef}
                        handleRowSelected={this.handleRowSelected}
                        sideBar="none"
                        gridTitle=""
                        GridWidth="760px"
                    />
                )}

                {!isReadOnlyUser && (
                    <section className="portfolio-overview-section portfolio-overview-table-section">
                        <header className="portfolio-overview-section-header">
                            <div>
                                <h3>Performance Decomposition</h3>
                            </div>
                        </header>
                        <div className="portfolio-overview-grid-shell">
                            <TorGrid
                                guikey="portfolioPerformanceDecomposition"
                                isHideDateInputs={true}
                                isHideSaveGridLayout={true}
                                rowData={this.props.gridData}
                                gridIdentityColumn="pnl_id"
                                groupIncludeFooter={true}
                                groupIncludeTotalFooter={true}
                                suppressExpandablePivotGroups={true}
                                className="dashboardgrid portfolio-overview-summary-grid"
                                rowGroupPanelShow="none"
                                enableFilter={false}
                                groupBy={this.props.GroupBy}
                                domLayout="autoHeight"
                                defaultColDef={defaultColDef}
                                sideBar="none"
                                gridTitle=""
                            />
                        </div>
                    </section>
                )}

                {!isReadOnlyUser && (
                    <section className="portfolio-overview-section">
                        <header className="portfolio-overview-section-header">
                            <div>
                                <h3>Historical CTR</h3>
                            </div>
                        </header>
                        <div className="portfolio-chart-grid portfolio-performance-chart-grid">
                            <article className="portfolio-chart-card">
                                <header><h4>CTR and Cumulative CTR</h4></header>
                                <div className="portfolio-chart-canvas portfolio-performance-chart-canvas">
                                    <ChartDisplay
                                        chartTitle=""
                                        chartType="cartesian-pnl"
                                        xKey="date"
                                        yKeys={["sum"]}
                                        yNames={["CTR"]}
                                        yKeyLine="cumSum"
                                        data={this.aggregateData()}
                                        corporate={true}
                                    />
                                </div>
                            </article>
                        </div>
                    </section>
                )}

                <section className="portfolio-performance-ranking-grid">
                    {rankingGrids.map(grid =>
                        <article className="portfolio-overview-section portfolio-overview-ranking-card" key={grid.guikey}>
                            <header className="portfolio-overview-section-header">
                                <div>
                                    <h3>{grid.title}</h3>
                                </div>
                            </header>
                            <div className="portfolio-overview-grid-shell">
                                <TorGrid
                                    guikey={grid.guikey}
                                    isHideDateInputs={true}
                                    isHideSaveGridLayout={true}
                                    rowData={this.props.gridData}
                                    ignoreBlanks="pnl total deal"
                                    domLayout="autoHeight"
                                    suppressExpandablePivotGroups={true}
                                    className="dashboardgrid nototal portfolio-overview-top-grid portfolio-performance-ranking-table"
                                    rowGroupPanelShow="none"
                                    enableFilter={false}
                                    suppressHorizontalScroll={true}
                                    defaultColDef={defaultColDef}
                                    sideBar="none"
                                    gridTitle={grid.title}
                                    pagination={true}
                                    gridIdentityColumn="pnl_id"
                                />
                            </div>
                        </article>
                    )}
                </section>
            </div>
        );
    }
}
export default PortfolioPerformanceOverview;